import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-google-map',
  imports: [],
  templateUrl: './loader-google-map.component.html',
  styleUrl: './loader-google-map.component.css'
})
export class LoaderGoogleMapComponent {

}
